import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';

import { LoadingSpinner } from './LoadingSpinner';
import { isPlanningPath, PlanningRouteShell } from './PlanningRouteShell';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * ProtectedRoute component that enforces authentication
 * Redirects to login if user is not authenticated
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Keep planning workspace geometry mounted while authentication is checked.
  if (isLoading) {
    if (isPlanningPath(location.pathname)) {
      return <PlanningRouteShell />;
    }

    return (
      <div
        className="protected-wrapper"
        role="status"
        aria-label="Loading page"
        aria-live="polite"
      >
        <LoadingSpinner />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Render protected content if authenticated
  return <>{children}</>;
};
